import React from 'react';
import LoadingButton from '@mui/lab/LoadingButton';

interface LoadMoreProps {
  onClick: () => void;
  hasMore: boolean;
  loading: boolean;
}

const LoadMoreButton: React.FC<LoadMoreProps> = ({
  onClick,
  hasMore,
  loading
}) => {
  if (!hasMore) {
    return (
      <div className='category__load-more'>
        <h3>You've found them all!</h3>
      </div>
    );
  }

  return (
    <div className='category__load-more'>
      <LoadingButton
        loading={loading}
        onClick={onClick}
        variant='contained'
        color='primary'
        disableElevation
      >
        Load More
      </LoadingButton>
    </div>
  );
};

export default LoadMoreButton;
